import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';

// inspired from https://codinglatte.com/posts/angular/angular-dynamic-form-fields-using-formarray/

@Component({
    selector: 'app-ei-multi-select',
    template: `

<form [formGroup]="form1" (submit)="submit()">
  <label>Name</label>
  <input formControlName="name" type="text">
  @if (form1.controls['name'].touched && form1.controls['name'].hasError('required')) {
    <span>
    Name is required! </span>
  }
  <label>Organization</label>
  <input formControlName="organization" type="text">

  <div formArrayName="contacts">
    @for (contact of contactFormGroup.controls; track contact; let i = $index) {
      <div>
        <div [formGroupName]="i">
          <div>
            <label>Type of Contact</label>
            <select (change)="changedFieldType(i)" formControlName="type" type="text">
              <option value="email">Email</option>
              <option value="phone">Phone</option>
            </select>
          </div>
          <div>
            <label>Contact Label</label>
            <input formControlName="name" type="text">
            @if (getContactsFormGroup(i).controls['name'].touched && getContactsFormGroup(i).controls['name'].hasError('required')) {
              <span
                >
              Label is required! </span>
            }
          </div>
          <div>
            <label>Email/Phone No.</label>
            <input formControlName="value" type="text">
            @if (getContactsFormGroup(i).controls['value'].touched && getContactsFormGroup(i).controls['value'].hasError('required')) {
              <span
                >
              Email/Phone no is required! </span>
            }
            @if (getContactsFormGroup(i).controls['value'].touched && getContactsFormGroup(i).controls['value'].hasError('email')) {
              <span
                >
              Email is not valid! </span>
            }
            @if (getContactsFormGroup(i).controls['value'].touched && getContactsFormGroup(i).controls['value'].hasError('pattern')) {
              <span
                >
              Phone no. is not valid! </span>
            }
          </div>
          <div>
            <button class="btn btn-danger" type="button" (click)="removeContact(i)"> Remove </button>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="card-body">
    <div class="col-12">
      <button type="button" (click)="addContact()"> Add Position </button>
      <button type="button" (click)="addContact()"> Add Contact </button>
      <button [disabled]="!form1.valid" type="submit"> Save User Profile
      </button>
    </div>
  </div>
</form>
`,
    styles: [],
    standalone: false
})
export class ExtraInfoSelectComponent implements OnInit, OnChanges
{
	// forms
	formLoading = false;
	contactListFormArray: UntypedFormArray;
	shortTermRentals = [];
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskId: number;
	@Input() form1: UntypedFormGroup;
	@Input() shortTermRentalId: number;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService) { }
	ngOnInit()
	{

		// trial
		this.form1 = this.formBuilder.group({
			name: [null, Validators.compose([Validators.required])],
			organization: [null],
			contacts: this.formBuilder.array([this.createContact()])
		});

		// set contactlist to the form control containing contacts
		this.contactListFormArray = this.form1.get('contacts') as UntypedFormArray;
		// end trial

	}


	// returns all form groups under contacts
	get contactFormGroup()
	{
		return this.form1.get('contacts') as UntypedFormArray;
	}

	// contact formgroup
	createContact(): UntypedFormGroup
	{
		return this.formBuilder.group({
			type: ['email', Validators.compose([Validators.required])], // i.e Email, Phone
			name: [null, Validators.compose([Validators.required])], // i.e. Home, Office
			value: [null, Validators.compose([Validators.required, Validators.email])]
		});
	}

	// add a contact form group
	addContact()
	{
		this.contactListFormArray.push(this.createContact());
	}

	// remove contact from group
	removeContact(index)
	{
		this.contactListFormArray.removeAt(index);
	}

	// triggered to change validation of value field type
	changedFieldType(index)
	{
		let validators = null;

		if (this.getContactsFormGroup(index).controls['type'].value === 'email')
		{
			validators = Validators.compose([Validators.required, Validators.email]);
		} else
		{
			validators = Validators.compose([
				Validators.required
			]);
		}

		this.getContactsFormGroup(index).controls['value'].setValidators(validators);
		this.getContactsFormGroup(index).controls['value'].updateValueAndValidity();
	}

	// get the formgroup under contacts form array
	getContactsFormGroup(index): UntypedFormGroup
	{
		const formGroup = this.contactListFormArray.controls[index] as UntypedFormGroup;
		return formGroup;
	}

	// method triggered when form is submitted
	submit()
	{
		console.log(JSON.stringify(this.form1.value));
	}


	ngOnChanges()
	{

	}
}
